<template>
    <div>
        <v-progress-circular v-if="!arranged" indeterminate/>
        <div class="working-pad" v-if="backgroundImage && arranged">
            <v-stage ref="stage" :config="stage">
                <v-layer>
                    <v-image :config="{image: backgroundImage}"/>
                    <v-rect
                        @mouseenter="handleMouseEnter"
                        @mouseleave="handleMouseLeave"
                        v-for="edge in edges"
                        :config="edge"
                        :key="edge.id"
                        @click="selectEdge(edge)"
                    />
                </v-layer>
            </v-stage>
        </div>
        <v-alert
            color="info"
            outlined
            border="bottom"
            dismissible>
            {{ $t('steps.editor.message') }}
        </v-alert>
    </div>
</template>

<script>
    const horizontal = 'horizontal'
    const vertical = 'vertical'
    const margin = 20

    export default {
        name: "Modifier",
        props: ['index', 'arranged'],
        data() {
            return {
                backgroundImage: null,
                edges: []
            }
        },
        computed: {
            stage() {
                return {
                    width: this.backgroundImage.width,
                    height: this.backgroundImage.height
                }
            },
            surface() {
                return this.$store.state.configurator.surfaces[this.index]
            },
            edge() {
                return id => this.surface.edges.find(edge => edge.id === id)
            },
            invokers() {
                return [this.index, this.arranged]
            }
        },
        methods: {
            selectEdge(edge) {
                edge.selected = !edge.selected
                edge.opacity = edge.selected ? 1 : 0.4
                edge.shadowBlur = edge.selected ? 7 : 0
                this.$store.commit(edge.selected ? 'appendEdge' : 'removeEdge', {
                    surface: this.index,
                    edge
                })
            },
            drawEdges() {
                this.edges = []
                this.surface.polygon.forEach((segment, index) => {
                    let isSelected = !!this.edge(index)
                    let edge = {
                        id: index,
                        segment,
                        fill: '#21a2e8',
                        opacity: isSelected ? 1 : 0.4,
                        shadowBlur: isSelected ? 7 : 0,
                        selected: isSelected,
                        cornerRadius: 5,
                        x: Math.min(segment.points[0].x, segment.points[1].x) + margin - 5,
                        y: Math.min(segment.points[0].y, segment.points[1].y) + margin - 5
                    }
                    switch (segment.direction) {
                        case horizontal:
                            edge.width = Math.max(segment.points[0].x, segment.points[1].x) + margin + 5 - edge.x
                            edge.height = 10
                            break;
                        case vertical:
                            edge.width = 10
                            edge.height = Math.max(segment.points[0].y, segment.points[1].y) + margin + 5 - edge.y
                            break;
                    }
                    this.edges.push(edge)
                })
            },
            setUp() {
                this.backgroundImage = null
                const image = new window.Image()
                image.onload = () => {
                    this.backgroundImage = image
                    this.drawEdges()
                }
                image.src = this.surface.workspace
            },
            handleMouseEnter(e) {
                const stage = e.target.getStage()
                stage.container().style.cursor = "pointer"
            },
            handleMouseLeave(e) {
                const stage = e.target.getStage()
                stage.container().style.cursor = "default"
            }
        },
        watch: {
            invokers() {
                if (this.arranged) {
                    this.setUp()
                }
            }
        }
    }
</script>

<style scoped>
    .working-pad {
        max-width: 100%;
        max-height: 720px;
        margin-bottom: 12px;
        overflow-y: auto;
    }
</style>
